var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.pagination.last_page > 1
    ? _c(
        "div",
        { staticClass: "mt-3", attrs: { "aria-label": "Page navigation" } },
        [
          _c("div", { staticClass: "d-flex justify-content-center mb-3" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.enteredPage,
                  expression: "enteredPage",
                },
              ],
              staticClass: "form-control form-control-sm w-mx-content",
              attrs: {
                type: "number",
                min: "1",
                placeholder: _vm.Lang.get("messages.goto_page"),
              },
              domProps: { value: _vm.enteredPage },
              on: {
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  return _vm.getPage.apply(null, arguments)
                },
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.enteredPage = $event.target.value
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "pagination-block flex" }, [
            _c(
              "a",
              {
                staticClass: "page-btn flex",
                class: { disabled: _vm.pagination.current_page === 1 },
                attrs: { href: "#" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.changePage(1)
                  },
                },
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.Lang.get("pagination.first_page")) +
                    "\n    "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "ul",
              { staticClass: "pagination" },
              [
                _c(
                  "li",
                  {
                    staticClass: "page-item",
                    class: { disabled: _vm.pagination.current_page === 1 },
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "page-link next",
                        attrs: {
                          href: "#",
                          title: _vm.Lang.get("pagination.previous"),
                        },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.changePage(
                              _vm.pagination.current_page - 1
                            )
                          },
                        },
                      },
                      [_c("i", { staticClass: "fas fa-angle-double-right" })]
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm._l(_vm.pages, function (page) {
                  return _c(
                    "li",
                    {
                      key: page,
                      staticClass: "page-item",
                      class: { active: _vm.isCurrentPage(page) },
                    },
                    [
                      _c(
                        "a",
                        {
                          staticClass: "page-link",
                          attrs: { href: "#" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.changePage(page)
                            },
                          },
                        },
                        [_vm._v("\n          " + _vm._s(page) + "\n        ")]
                      ),
                    ]
                  )
                }),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    staticClass: "page-item",
                    class: {
                      disabled:
                        _vm.pagination.current_page >= _vm.pagination.last_page,
                    },
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "page-link previous",
                        attrs: {
                          href: "#",
                          title: _vm.Lang.get("pagination.next"),
                        },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.changePage(
                              _vm.pagination.current_page + 1
                            )
                          },
                        },
                      },
                      [_c("i", { staticClass: "fas fa-angle-double-left" })]
                    ),
                  ]
                ),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "page-btn flex",
                class: {
                  disabled:
                    _vm.pagination.current_page === _vm.pagination.last_page,
                },
                attrs: { href: "#" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.changePage(_vm.pagination.last_page)
                  },
                },
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.Lang.get("pagination.last_page")) +
                    "\n    "
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "pages-number flex mt-2" }, [
            _vm._v("\n    " + _vm._s(_vm.Lang.get("messages.total")) + " "),
            _c("span", [_vm._v(_vm._s(_vm.pagination.total))]),
            _vm._v(
              "\n    " +
                _vm._s(_vm.Lang.get("messages.pagination.records")) +
                " ,\n    " +
                _vm._s(_vm.Lang.get("messages.pagination.showing_from")) +
                "\n    "
            ),
            _c("span", [_vm._v(_vm._s(_vm.pagination.from))]),
            _vm._v("\n    " + _vm._s(_vm.Lang.get("messages.to")) + "\n    "),
            _c("span", [_vm._v(_vm._s(_vm.pagination.to))]),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }